'use client';

import React from 'react';

export interface FlagsContextProps {
  //pdp-config flags
  enableStorefrontDowntime?: boolean;

  EF_enableReenrollment?: boolean;
  clientReferer?: string;
  indexAvailableBundlesConfiguration?: {
    AvailableBundles: { bundleName: string; bundleURL: string }[];
  };
  enableEnrollmentRenamingFee?: boolean;
  enableBackOrder?: boolean;
}

export const FlagsContext = React.createContext<FlagsContextProps | undefined>(
  undefined
);

interface FlagsProviderProps extends FlagsContextProps {
  children: React.ReactNode;
}

export const FlagsProvider: React.FC<FlagsProviderProps> = ({
  children,
  ...flags
}) => <FlagsContext.Provider value={flags}>{children}</FlagsContext.Provider>;
